import { defineStore } from 'pinia';
import type { NavigationNode } from '../../types/link';
import { ref, watch } from 'vue';
import { useStoreAllNavs } from './allNavs';

export type StoreSecondaryNav = {
  items?: NavigationNode[];
};

const storeId = 'store-secondary-nav';

export const useStoreSecondaryNav = defineStore(storeId, () => {
  const storeAllNavs = useStoreAllNavs();
  const items = ref<StoreSecondaryNav['items']>();

  async function fetchItems() {
    if (!storeAllNavs.allNavs?.secondaryNav) {
      console.error(`${storeId} >>> error`, 'allNavsStore is not available');
      return;
    }

    const navItems = new Array(storeAllNavs.allNavs.secondaryNav);

    if (navItems) {
      items.value = navItems;
    }
  }

  watch(storeAllNavs, () => {
    if (storeAllNavs.allNavs && !items.value) {
      fetchItems();
    }
  });

  return {
    items,
  };
});
